<template>
<section class="notice_view">
    <div class="wrap">
        <div class="notice_view_info">
            <span>{{noticeItem.startDt}}</span>
            <p>{{noticeItem.title}}</p>
        </div>
    </div>

    <div class="notice_contents">
        {{noticeItem.content}}
    </div>
</section>
</template>

<script>
export default {
    name:'NoticeInfo',
    async created () {
        this.$store.state.headerTitle = '공지사항 보기';
        await this.getItem();
        this.$store.commit('SHOW_ONLOAD');
    },
    data() {
        return {
            noticeItem: null,
        }
    },
    computed: {
        noticeId(){
            return this.$route.params.noticeId;
        }
    },
    methods: {
        getItem() {
            this.$store.dispatch('GET_BOARD', this.noticeId)
            .then((data)=>{
                this.noticeItem = data;
            })
            .catch((e)=>{
                this.apiCatch(e);
            });
        }
    },
}
</script>

<style lang="scss" scoped>

</style>